import { Link } from 'react-router-dom';
import { propFirmLogos } from '../data/propFirmLogos';
import { StarRating } from './StarRating';
import { PromoCTAButton } from './PromoCTAButton';
import type { PropFirm } from '../types';

interface ReviewCardProps {
  firm: PropFirm;
}

export function ReviewCard({ firm }: ReviewCardProps) {
  const logo = propFirmLogos[firm.id]?.logo;
  const discount = firm.evaluation?.discount;

  return (
    <div className="bg-white/10 backdrop-blur rounded-xl shadow-md p-6 flex flex-col justify-between hover:scale-[1.01] transition-transform">
      <div>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 flex items-center justify-center bg-black rounded">
            <img src={logo} alt={firm.name} className="w-8 h-8 object-contain" />
          </div>
          <div>
            <Link to={`/reviews/${firm.id}`} className="font-bold text-lg text-yellow-100 hover:text-yellow-300">
              {firm.name}
            </Link>
            <div className="flex items-center gap-2 text-sm text-yellow-300">
              <StarRating rating={firm.rating} />
              ({firm.reviewCount.toLocaleString()})
            </div>
          </div>
        </div>

        <p className="text-sm text-yellow-200 mb-4 line-clamp-3">{firm.description}</p>

        <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
          <div>
            <span className="text-yellow-400 block mb-1">Max Funding</span>
            <span className="font-semibold text-white">{firm.features.maxFunding}</span>
          </div>
          <div>
            <span className="text-yellow-400 block mb-1">Profit Split</span>
            <span className="font-semibold text-white">{firm.features.profitSplit}</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2 mt-4">
        <Link
          to={`/reviews/${firm.id}`}
          className="w-full h-11 inline-flex items-center justify-center gap-2 font-semibold bg-white/10 hover:bg-white/20 text-yellow-400 rounded-lg transition"
        >
          📖 Read Review
        </Link>
        <PromoCTAButton
          firmId={firm.id}
          code={discount?.code}
          price={firm.evaluation.fee.toString()}
          discountedPrice={discount?.discountedPrice?.toString()}
          validUntil={discount?.validUntil}
          firstPurchaseOnly={discount?.firstPurchaseOnly}
        />
      </div>
    </div>
  );
}

export default ReviewCard;
